import React, { useState } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

// CATERING SECTION - Table-based (Greiner style) with interactive banners
const SilentCzechCatering = () => {
  // State pro interaktivní položky (Live Cooking)
  const [liveCookingItems, setLiveCookingItems] = useState({
    paella: { selected: false, price: 20000, name: 'Live Paella — od rodilého Španěla Miguela' },
    colorSushi: { selected: false, price: 25000, name: 'COLOR SUSHI - Lukáš Neckář show' }
  });

  const toggleLiveCooking = (key) => {
    setLiveCookingItems(prev => ({
      ...prev,
      [key]: { ...prev[key], selected: !prev[key].selected }
    }));
  };

  // Vypočítat celkovou cenu live cooking
  const liveCookingTotal = Object.values(liveCookingItems)
    .filter(item => item.selected)
    .reduce((sum, item) => sum + item.price, 0);
  const cateringData = {
    lunch: {
      title: "OBĚD (12:00 - 15:00)",
      subtitle: "Formou švédských stolů",
      heroImage: "https://images.unsplash.com/photo-1693463399197-e6063452cf07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYnVmZmV0JTIwZm9vZCUyMGRpc3BsYXklMjBjYXRlcmluZ3xlbnwwfHx8fDE3NzQ1MjI2Mjl8MA&ixlib=rb-4.1.0&q=85",
      sections: [
        {
          name: "Maso grilované v celku, krájené před hosty",
          items: [
            { name: "Plněné sele", portion: "1000g (kg)", count: 10, pricePerUnit: 799, total: 7990 },
            { name: "Vepřová kýta", portion: "1000g (kg)", count: 10, pricePerUnit: 599, total: 5990 }
          ]
        },
        {
          name: "Teplý raut",
          items: [
            { name: "Grilovaný losos s bylinkovou omáčkou", portion: "100g", count: 40, pricePerUnit: 165, total: 6600 },
            { name: "Medailonky z vepřové panenky, pepřová omáčka", portion: "100g", count: 40, pricePerUnit: 130, total: 5200 },
            { name: "Vepřová žebírka v BBQ marinádě", portion: "200g", count: 40, pricePerUnit: 109, total: 4360 },
            { name: "Kuřecí paličky ve sweet chilli omáčce", portion: "200g", count: 40, pricePerUnit: 89, total: 3560 },
            { name: "Kuřecí roláda plněná vepřovým masem a špenátem s omáčkou demi glace", portion: "50g", count: 40, pricePerUnit: 60, total: 2400 }
          ]
        },
        {
          name: "Přílohy",
          items: [
            { name: "Pečené zelené lusky se slaninkou", portion: "100g", count: 100, pricePerUnit: 45, total: 4500 },
            { name: "Pečené brambory grenaille na bylinkách a másle", portion: "100g", count: 200, pricePerUnit: 45, total: 9000 },
            { name: "Grilovaná sezonní zelenina", portion: "100g", count: 100, pricePerUnit: 50, total: 5000 },
            { name: "Grilovaná kukuřice", portion: "100g", count: 50, pricePerUnit: 55, total: 2750 },
            { name: "Zelný salát coleslaw", portion: "100g", count: 100, pricePerUnit: 30, total: 3000 },
            { name: "Míchaný zeleninový salát, balkánský sýr, medovo hořčičný dresing", portion: "100g", count: 100, pricePerUnit: 50, total: 5000 }
          ]
        },
        {
          name: "Omáčky a dresingy",
          items: [
            { name: "Francouzský, bylinkový, česnekový dresing", portion: "50g", count: 100, pricePerUnit: 25, total: 2500 }
          ]
        },
        {
          name: "Studený raut",
          items: [
            { name: "Kuřecí banketní řízečky obalované v sezamu", portion: "50g", count: 100, pricePerUnit: 55, total: 5500 },
            { name: "Vepřové banketní řízečky z panenky marinované v česneku", portion: "50g", count: 50, pricePerUnit: 65, total: 3250 },
            { name: "Tatarák, topinky", portion: "50g", count: 50, pricePerUnit: 126, total: 6300 },
            { name: "Anglický roastbeef", portion: "50g", count: 50, pricePerUnit: 119, total: 5950 }
          ]
        },
        {
          name: "Doplňky",
          items: [
            { name: "Koš čerstvého banketního pečiva", portion: "15 ks", count: 200, pricePerUnit: 15, total: 3000 }
          ]
        }
      ],
      totalPrice: 106910
    },
    liveCookingShow: {
      title: "LIVE COOKING SHOW (15:00 - 17:00)",
      subtitle: "Interaktivní gastronomický zážitek",
      heroImage: "https://images.unsplash.com/photo-1671612451404-f4f8fc5fe25e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwYnVmZmV0JTIwZm9vZCUyMGRpc3BsYXklMjBjYXRlcmluZ3xlbnwwfHx8fDE3NzQ1MjI2Mjl8MA&ixlib=rb-4.1.0&q=85",
      sections: [
        {
          name: "Live Cooking stanice",
          items: [
            { name: "Paella Španělsko - Miguel", portion: "paušál", count: 1, pricePerUnit: 20000, total: 20000, isInteractive: true, key: 'paella' },
            { 
              name: "COLOR SUSHI - Lukáš Neckář show", 
              portion: "paušál", 
              count: 1, 
              pricePerUnit: 25000, 
              total: 25000, 
              isInteractive: true, 
              key: 'colorSushi',
              description: `
🍣 Až 3hodinová live sushi show s interakcí s hosty
📦 200 bambusových lodiček × 3 ks sushi = 600 kusů celkem
🎨 COLOR SUSHI koncept:
   • Růžová rýže (červená řepa) + takuan
   • Žlutá kari rýže + marinovaná variace
   • Klasická bílá rýže + okurka
✅ Kompletní servis (sojová omáčka, wasabi, zázvor, hůlky)
👨‍🍳 Kuchař s TV zkušenostmi + průběžné rolování
🎬 Video: youtube.com/watch?v=ObCpGk7tgzk

Cena zahrnuje: suroviny, přípravu, live show, catering i dopravu
              `.trim()
            }
          ]
        }
      ],
      totalPrice: liveCookingTotal
    },
    coffeeBreak: {
      title: "COFFEE BREAK (16:00 - 18:00)",
      subtitle: "Formou švédských stolů",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/tdtdtgvc__AMK1373.jpg",
      sections: [
        {
          name: "Kanapky",
          items: [
            { name: "S parmskou šunkou", portion: "50g", count: 50, pricePerUnit: 49, total: 2450 },
            { name: "Se sýrem Brie", portion: "50g", count: 50, pricePerUnit: 49, total: 2450 },
            { name: "S uzeným lososem", portion: "50g", count: 50, pricePerUnit: 55, total: 2750 },
            { name: "Mini wrapy", portion: "50g", count: 50, pricePerUnit: 55, total: 2750 },
            { name: "Mini burger", portion: "50g", count: 50, pricePerUnit: 80, total: 4000 }
          ]
        },
        {
          name: "Dezert",
          items: [
            { name: "Carrot cake - mrkvový dort s ořechy", portion: "180g", count: 60, pricePerUnit: 89, total: 5340 },
            { name: "Čokoládový dort s malinami", portion: "100g", count: 70, pricePerUnit: 89, total: 6230 },
            { name: "Karamelový dort s datlemi", portion: "100g", count: 70, pricePerUnit: 89, total: 6230 }
          ]
        }
      ],
      totalPrice: 34200
    },
    dinner: {
      title: "VEČEŘE (19:00 - 21:00)",
      subtitle: "Podávání z foodtrucků",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/f2myg582_FoodTruck.jpg",
      sections: [
        {
          name: "Hlavní chody",
          items: [
            { name: "Hovězí žebra na přírodní topince z kváskového chleba, bbq, coleslaw", portion: "150g", count: 50, pricePerUnit: 285, total: 14250 },
            { name: "Smash beef burger (Irský chuckroll, slanina, cheddar, polníček, okurka, rajče, domácí bun)", portion: "150g", count: 50, pricePerUnit: 210, total: 10500 },
            { name: "Quesadillas - zapečená tortilla s čedarem, mozzarellou, pomalu pečeným trhaným masem", portion: "100g", count: 50, pricePerUnit: 210, total: 10500 },
            { name: "Tacos Combo - Kombinace tří různých tacos. Malá kukuřičná tortila, trhaná BBQ vepřová", portion: "120g", count: 50, pricePerUnit: 210, total: 10500 }
          ]
        },
        {
          name: "Dezert",
          items: [
            { name: "Vdolečky", portion: "10 ks", count: 200, pricePerUnit: 15, total: 3000 },
            { name: "Makové a ořechové koláčky", portion: "20 ks", count: 100, pricePerUnit: 15, total: 1500 },
            { name: "Frgále", portion: "50 ks", count: 100, pricePerUnit: 35, total: 3500 },
            { name: "Zmrzlina kopečková", portion: "50 ks", count: 100, pricePerUnit: 35, total: 3500 }
          ]
        }
      ],
      totalPrice: 57250
    },
    drinks: {
      title: "NÁPOJOVÝ SERVIS — ALL INCLUSIVE (12:00 - 24:00)",
      subtitle: "Kompletní nápojové zázemí pro celou akci",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/1qpehocp__AMK1902.jpg",
      sections: [
        {
          name: "Degustace rumů (15:00 - 22:00)",
          items: [
            { name: "Degustace rumů — dle přesné spotřeby (min. 100 ks)", portion: "ks", count: "∞", pricePerUnit: 120, total: 12000 }
          ]
        },
        {
          name: "Koktejly mix vč. nealkoholických (15:00 - 24:00)",
          items: [
            { name: "Koktejly mix (Mojito, Piña Colada, Sex on the Beach, Gin Tonic, Aperol Spritz, Whiskey Sour, Cosmopolitan, Mai Tai, Cuba Libre) + nealkoholické — dle přesné spotřeby (min. 200 ks)", portion: "ks", count: "∞", pricePerUnit: 120, total: 24000 }
          ]
        },
        {
          name: "Pivo čepované",
          items: [
            { name: "Plzeňský Prazdroj — dle přesné spotřeby (min. 250 ks)", portion: "ks", count: "∞", pricePerUnit: 60, total: 15000 },
            { name: "Birell (nealkoholické) — dle přesné spotřeby (min. 100 ks)", portion: "ks", count: "∞", pricePerUnit: 50, total: 5000 },
            { name: "Birell Pomelo Grep — dle přesné spotřeby (min. 100 ks)", portion: "ks", count: "∞", pricePerUnit: 50, total: 5000 }
          ]
        },
        {
          name: "Nealkoholické nápoje",
          items: [
            { name: "Pepsi, Mirinda, 7up — dle přesné spotřeby (min. 100 ks)", portion: "ks", count: "∞", pricePerUnit: 50, total: 5000 },
            { name: "Red Bull — dle přesné spotřeby (min. 100 ks)", portion: "ks", count: "∞", pricePerUnit: 70, total: 7000 },
            { name: "Voda (perlivá / neperlivá) — dle přesné spotřeby (min. 150 ks)", portion: "ks", count: "∞", pricePerUnit: 40, total: 6000 }
          ]
        }
      ],
      totalPrice: 79000
    },
    staff: {
      title: "PERSONÁL & REŽIE",
      subtitle: "Obsluha, vybavení a logistika",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/mvetv4fd_290807044_434303445370941_8352434526447174514_n-3%281%29.jpg",
      sections: [
        {
          name: "Personál",
          items: [
            { name: "Kuchaři", portion: "hod", count: 60, pricePerUnit: 220, total: 13200 },
            { name: "Servírky / číšníci", portion: "hod", count: 80, pricePerUnit: 190, total: 15200 },
            { name: "Barmani", portion: "hod", count: 40, pricePerUnit: 210, total: 8400 }
          ]
        },
        {
          name: "Režie a vybavení",
          items: [
            { name: "Nádobí, příbory, sklo", portion: "paušál", count: 1, pricePerUnit: 8500, total: 8500 },
            { name: "Stoly, tepelné vany", portion: "paušál", count: 1, pricePerUnit: 6200, total: 6200 },
            { name: "Doprava a logistika", portion: "paušál", count: 1, pricePerUnit: 9500, total: 9500 },
            { name: "Koordinátor akce", portion: "hod", count: 12, pricePerUnit: 290, total: 3480 }
          ]
        }
      ],
      totalPrice: 64480
    }
  };

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-slate-950 to-[#020617]">
      <div className="max-w-7xl mx-auto">
        {/* Main Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 text-center">
          CATERING & GASTRO
        </h2>
        <p className="text-slate-400 text-lg mb-12 text-center max-w-3xl mx-auto">
          Kompletní gastronomický servis pro 200 hostů. Celodenní catering ve stylu evropských festivalů s live cooking stanicemi a food trucky.
        </p>

        {/* Visual Gallery - pouze 2 položky */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {/* Live Paella - Klikací */}
          <div 
            onClick={() => toggleLiveCooking('paella')}
            className={`relative group overflow-hidden rounded-xl border-2 transition-all cursor-pointer ${
              liveCookingItems.paella.selected 
                ? 'border-[#FF6B00] shadow-lg shadow-[#FF6B00]/30' 
                : 'border-white/10 hover:border-[#FF6B00]/50'
            }`}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/0oqd0z21_44319726_1091573427668908_8957835176973434880_n.jpg"
              alt="Live Paella" 
              className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent flex flex-col justify-end p-6">
              <div className="flex items-center gap-3 mb-2">
                {liveCookingItems.paella.selected ? (
                  <div className="w-8 h-8 bg-[#FF6B00] rounded-full flex items-center justify-center">
                    <CheckCircle2 className="w-6 h-6 text-white" />
                  </div>
                ) : (
                  <div className="w-8 h-8 border-2 border-white/50 rounded-full flex items-center justify-center">
                    <div className="w-4 h-4 bg-white/30 rounded-full"></div>
                  </div>
                )}
                <span className="text-[#FF6B00] font-bold text-2xl">20 000 Kč</span>
              </div>
              <p className="text-white font-bold text-xl">Live Paella — od rodilého Španěla Miguela</p>
              <p className="text-slate-300 text-sm mt-1">Klikněte pro přidání do rozpočtu</p>
            </div>
          </div>

          {/* COLOR SUSHI - Klikací */}
          <div 
            onClick={() => toggleLiveCooking('colorSushi')}
            className={`relative group overflow-hidden rounded-xl border-2 transition-all cursor-pointer ${
              liveCookingItems.colorSushi.selected 
                ? 'border-[#FF6B00] shadow-lg shadow-[#FF6B00]/30' 
                : 'border-white/10 hover:border-[#FF6B00]/50'
            }`}
          >
            <img 
              src="https://images.pexels.com/photos/36317042/pexels-photo-36317042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="COLOR SUSHI" 
              className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent flex flex-col justify-end p-6">
              <div className="flex items-center gap-3 mb-2">
                {liveCookingItems.colorSushi.selected ? (
                  <div className="w-8 h-8 bg-[#FF6B00] rounded-full flex items-center justify-center">
                    <CheckCircle2 className="w-6 h-6 text-white" />
                  </div>
                ) : (
                  <div className="w-8 h-8 border-2 border-white/50 rounded-full flex items-center justify-center">
                    <div className="w-4 h-4 bg-white/30 rounded-full"></div>
                  </div>
                )}
                <span className="text-[#FF6B00] font-bold text-2xl">25 000 Kč</span>
              </div>
              <p className="text-white font-bold text-xl">COLOR SUSHI - Lukáš Neckář show</p>
              <p className="text-slate-300 text-sm mt-1">Klikněte pro přidání do rozpočtu</p>
            </div>
          </div>
        </div>

        {/* Catering Sections */}
        {Object.entries(cateringData).map(([key, data]) => (
          <div key={key} className="mb-12">
            {/* Hero Image + Title */}
            <div className="relative h-64 rounded-t-xl overflow-hidden">
              <img 
                src={data.heroImage}
                alt={data.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent flex items-end">
                <div className="p-8 w-full">
                  <h3 className="text-3xl md:text-4xl font-bold text-white mb-2">
                    🍽️ {data.title}
                  </h3>
                  <p className="text-slate-300 text-lg">{data.subtitle}</p>
                </div>
              </div>
            </div>

            {/* Tables */}
            <div className="bg-slate-900/40 border border-white/10 rounded-b-xl p-6">
              {data.sections.map((section, idx) => (
                <div key={idx} className="mb-8 last:mb-0">
                  <h4 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                    <span className="w-2 h-2 bg-[#FF6B00] rounded-full"></span>
                    {section.name}
                  </h4>
                  
                  {/* Table */}
                  <div className="overflow-x-auto">
                    <table className="w-full text-left">
                      <thead>
                        <tr className="border-b border-white/10">
                          <th className="pb-3 text-slate-400 font-semibold">Položka</th>
                          <th className="pb-3 text-slate-400 font-semibold text-center">Gramáž/ks</th>
                          <th className="pb-3 text-slate-400 font-semibold text-center">
                            {key === 'staff' ? 'ks/hodin' : 'Počet porcí'}
                          </th>
                          <th className="pb-3 text-slate-400 font-semibold text-right">Cena/ks</th>
                          <th className="pb-3 text-slate-400 font-semibold text-right">Celkem</th>
                        </tr>
                      </thead>
                      <tbody>
                        {section.items.map((item, itemIdx) => (
                          <>
                            <tr key={itemIdx} className="border-b border-white/5 last:border-0">
                              <td className="py-3 text-white">
                                {item.name}
                                {item.isInteractive && liveCookingItems[item.key]?.selected && (
                                  <span className="ml-2 text-xs bg-[#FF6B00] text-white px-2 py-1 rounded">PŘIDÁNO</span>
                                )}
                                {item.isInteractive && !liveCookingItems[item.key]?.selected && (
                                  <span className="ml-2 text-xs bg-slate-700 text-slate-400 px-2 py-1 rounded">NEPŘIDÁNO</span>
                                )}
                              </td>
                              <td className="py-3 text-center">
                                <span className="text-green-400 font-semibold">{item.portion}</span>
                              </td>
                              <td className="py-3 text-white text-center">{item.count}</td>
                              <td className="py-3 text-slate-300 text-right">{item.pricePerUnit.toLocaleString('cs-CZ')} Kč</td>
                              <td className="py-3 text-right">
                                {item.isInteractive ? (
                                  <span className={`font-bold ${liveCookingItems[item.key]?.selected ? 'text-[#FF6B00]' : 'text-slate-600'}`}>
                                    {item.total.toLocaleString('cs-CZ')} Kč
                                  </span>
                                ) : (
                                  <span className="text-[#FF6B00] font-bold">{item.total.toLocaleString('cs-CZ')} Kč</span>
                                )}
                              </td>
                            </tr>
                            {item.description && (
                              <tr key={`${itemIdx}-desc`} className="border-b border-white/5">
                                <td colSpan="5" className="py-4 px-4 bg-slate-900/30">
                                  <div className="text-slate-300 text-sm whitespace-pre-line leading-relaxed">
                                    {item.description}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}

              {/* Section Total */}
              <div className="mt-6 pt-6 border-t border-white/20 flex justify-between items-center">
                <span className="text-white font-bold text-xl">Celkem {data.title.split('(')[0].trim()}:</span>
                <span className="text-[#FF6B00] font-bold text-2xl">{data.totalPrice.toLocaleString('cs-CZ')} Kč</span>
              </div>
            </div>
          </div>
        ))}

        {/* Grand Total */}
        <div className="mt-12 bg-gradient-to-r from-[#FF6B00]/20 to-[#FF6B00]/10 border-2 border-[#FF6B00]/50 rounded-xl p-8">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-2xl font-bold text-white mb-2">CELKOVÝ CATERING</h3>
              <p className="text-slate-300">Včetně všech služeb, personálu a režie</p>
              <p className="text-slate-400 text-sm mt-2">*Vyúčtování na základě reálné spotřeby nápojů</p>
            </div>
            <div className="text-right">
              <div className="text-5xl font-bold text-[#FF6B00]">
                {(cateringData.lunch.totalPrice + 
                  cateringData.liveCookingShow.totalPrice +
                  cateringData.coffeeBreak.totalPrice + 
                  cateringData.dinner.totalPrice + 
                  cateringData.drinks.totalPrice + 
                  cateringData.staff.totalPrice).toLocaleString('cs-CZ')} Kč
              </div>
              <p className="text-slate-400 text-sm mt-2">Orientační kalkulace pro 200 hostů</p>
              <p className="text-slate-300 text-xs mt-1">*Vyúčtování na základě reálné spotřeby nápojů</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SilentCzechCatering;
